/**
 * Internal-link-hub data access for the de-orphan link blocks (city / brand /
 * hub pages). The link indexes are NO LONGER bundled — the SSR server injects
 * the per-page slice as `window.__LINK_HUB_DATA__` (read on first render /
 * hydration), and client-side SPA navigation fetches the slice from
 * `/_data/links/...`. This keeps ~106KB gz of link JSON out of main.js while
 * keeping the links in the server-rendered HTML (crawlable).
 */

/**
 * Read the SSR-injected payload if it matches the page (kind + key).
 * Returns null if absent or stale (e.g. left over from a prior SPA route).
 */
export function readInjectedLinkData(kind, key) {
  const g =
    (typeof window !== 'undefined' && window.__LINK_HUB_DATA__) ||
    (typeof global !== 'undefined' && global.__LINK_HUB_DATA__) ||
    null;
  if (g && g.kind === kind && (key === undefined || g.key === key)) return g;
  return null;
}

/** One-shot consume: read the injected payload then clear it so a later SPA
 *  navigation never reuses a stale slice. Safe to call on the client only. */
export function consumeInjectedLinkData(kind, key) {
  const data = readInjectedLinkData(kind, key);
  if (typeof window !== 'undefined' && window.__LINK_HUB_DATA__) {
    try { delete window.__LINK_HUB_DATA__; } catch (e) { window.__LINK_HUB_DATA__ = undefined; }
  }
  return data;
}

/** Fetch a link slice for client-side navigation. Resolves to the payload or null. */
export function fetchLinkData(url) {
  return fetch(url)
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);
}
